import { useEffect } from 'react'
import { motion } from 'framer-motion'
import { Router } from 'next/router'
import Close from 'components/svg/Close'
import { mobileMenuMaxWidth } from 'constants/styles'
import { headers as ease } from 'constants/easings'

type FlyoutProps = {
	children: any
	active: boolean
	onClose: () => void
}

export default function Flyout({ children, active, onClose }: FlyoutProps ) {
	// Hide menu when navigating to another (dynamic) page
	useEffect( () => {
		if ( active ) {
			Router.events.on( 'routeChangeComplete', onClose )
			return () => Router.events.off( 'routeChangeComplete', onClose )
		}
	}, [ active ] )

	const hideOnBackdropClick = e => {
		if ( e.target.className === 'backdrop' ) onClose()
	}

	const initial = 'hidden'
	const animate = ( active ? 'visible' : 'hidden' )
	const variants = {
		hidden: {
			x: '-100%',
		},
		visible: {
			x: 0,
		},
	}

	return (
		<div className="menu" onClick={hideOnBackdropClick}>
			<motion.div
				{...{ variants, initial, animate } }
				transition={{ duration: 1, ease, delayChildren: .3 }}
				className="backdrop"
			>
				<div className="cf">
					<div>
						{children}
					</div>
					<a
						aria-label="Close Menu"
						className="close"
						onClick={onClose}
					>
						<Close />
					</a>
				</div>
			</motion.div>
			<style jsx>{`
				.menu {
					pointer-events: ${( active ? 'auto' : 'none' )};
				}
				.menu > :global( div ) {
					position: fixed;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					z-index: 2;
				}
				.cf {
					position: relative;
					height: 100%;
					width: 66%;
					max-width: 1000px;
					display: flex;
					justify-content: center;
					align-items: center;
					background-color: white;
					box-shadow: ${( active ? '6px 2px 29px 0 rgba( 0, 0, 0, 0.15 )' : 'none' )};
					transition: ${( active ? 'none' : 'box-shadow .5s 1s' )};
					overflow: auto;
				}
				@media ( min-width: 880px ) {
					.cf {
						padding: 6%;
					}
				}
				.cf > div {
					width: 100%;
					max-height: 100%;
					display: flex;
					justify-content: space-between;
					align-items: flex-start;
				}
				.cf ul a::after {
					height: 3px;
					left: 1px;
					right: 1px;
				}
				.close {
					position: absolute;
					top: 56px;
					right: 56px;
					cursor: pointer;
				}
				@media ( max-width: ${mobileMenuMaxWidth}px ) {
					.cf {
						width: 90%;
						padding: 40px;
					}
					.menu > :global( div ) {
						z-index: 3;
					}
					.close {
						top: 48px;
						right: 40px;
					}
				}
			`}</style>
		</div>
	)
}
